import React, { Component } from "react";

import { Helmet } from "react-helmet";

import Hero from "components/PageHero/Hero";
import TextBlock from "components/TextBlock/TextBlock";
import ImageGridItem from "components/ImageGrid/ImageGridItem";
import ButtonContainer from "components/Button/Button-container";
import Button from "components/Button/Button";
import { siteTitle } from "helpers/Helpers";
import Rellax from "rellax";
import LazyLoad from "react-lazyload";
import { I18n } from "react-i18next";
import i18n from "../i18n";

//Images
import Over from "assets/images/Homepage/Homepage_FPG_video_header_NIEUW_optie1.jpg";

import Roots from "assets/images/Homepage/Homepage_FPG_Assorti_Green-Energy.jpg";
import RootsHq from "assets/images/Homepage/hq/Homepage_FPG_Assorti_Green-Energy.jpg";

import Ficus from "assets/images/Homepage/ficus.jpg";
import FicusHq from "assets/images/Homepage/hq/ficus.jpg";

import Curcuma from "assets/images/Homepage/Homepage_FPG_Assorti_Curcuma-Close.jpg";
import CurcumaHq from "assets/images/Homepage/hq/Homepage_FPG_Assorti_Curcuma-Close.jpg";

import Hibisqs from "assets/images/Homepage/hibiscus.jpg";
import HibisqsHq from "assets/images/Homepage/hq/hibiscus.jpg";

export default class Home extends Component {
  componentDidMount() {
    document.body.classList.add("home-page");
    siteTitle(this.props.title);
    new Rellax(".parallax-logo", {
      speed: 4,
      center: false,
      round: true,
      vertical: true,
      horizontal: false,
    });
  }
  componentWillUnmount() {
    document.body.classList.remove("home-page");
  }
  render() {
    return [
      <Helmet key="head">
        <meta charSet="utf-8" />
        <title>
          Forever Plants | Tropisch & Exotisch | Potplanten voor een groenere
          werelds
        </title>
        <meta
          property="og:image"
          content={`${process.env.REACT_APP_SAFE_URL}${Over}`}
        />
        <meta
          name="description"
          content="Een familiebedrijf, een innovatief bedrijf, een gelukkig bedrijf. Waar op de meest slimme en duurzame manier planten worden gekweekt, culturen samenkomen en innovatie stimuleren. Al meer dan 30 jaar zijn we gespecialiseerd in het produceren van tropische planten."
        />
        <meta
          property="og:description"
          content="Een familiebedrijf, een innovatief bedrijf, een gelukkig bedrijf. Waar op de meest slimme en duurzame manier planten worden gekweekt, culturen samenkomen en innovatie stimuleren. Al meer dan 30 jaar zijn we gespecialiseerd in het produceren van tropische planten."
        />
      </Helmet>,
      <span className="parallax-logo" key="logo" />,
      <I18n>
        {(t, { i18n }) => (
          <main id="pageWrapper" key="content">
            <div className="wrapper-hero-video">
              <Hero
                imageSrc={Over}
                videoId="477129281"
                channel="vimeo"
                showSubtitle
              />
            </div>
            <div className="wrapper">
              <section>
                <TextBlock
                  title={t("homeOurAssortimentTitle")}
                  subtitle={t("homeOurAssortimentSubTitle")}
                >
                  {t("homeOurAssortimentText")}{" "}
                  <Button to="contact" delay={true}>
                    {t("homeContactBtn")}
                  </Button>{" "}
                  {t("homeOurAssortimentText2")}{" "}
                  <a
                    href="https://www.plantsome.nl/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-anchor"
                  >
                    Plantsome
                  </a>
                  .
                </TextBlock>
              </section>
              <section className="mt30">
                <LazyLoad height={300}>
                  <div className="ImageGrid flex flex-justify flex-wrap">
                    <ImageGridItem
                      imageSrc={Roots}
                      imageSrcHq={RootsHq}
                      title="Green Energy"
                    />
                    <ImageGridItem
                      imageSrc={Ficus}
                      imageSrcHq={FicusHq}
                      title="ficus"
                    />
                    <ImageGridItem
                      imageSrc={Curcuma}
                      imageSrcHq={CurcumaHq}
                      title="curcuma"
                    />
                    <ImageGridItem
                      imageSrc={Hibisqs}
                      imageSrcHq={HibisqsHq}
                      title="hibisqs"
                    />
                  </div>
                </LazyLoad>
              </section>
              <section className="mt10">
                <TextBlock>
                  <b>{t("homeViewFullAssortment")}</b>
                </TextBlock>
                <ButtonContainer
                  buttonText1={t("homeButtonContainer")}
                  buttonText2={t("homeButtonContainerFlora")}
                  classButton1="btn"
                  classButton2="btn btn-modifier"
                  linkButton1="assortiment"
                  linkButton2="https://www.floraxchange.nl/Account/Kweker/533/Forever-Plants-Group"
                />
              </section>
              <section className="mt90">
                <TextBlock
                  title={t("homeGreenerTitle")}
                  subtitle={t("homeGreenerSubTitle")}
                >
                  {t("homeGreenertext")}
                </TextBlock>
                <Button className="btn" to="over-fpg" onClick="">
                  {t("homeMoreAboutUs")}
                </Button>
              </section>
              <section className="textblock-grid flex mt80 mb100">
                <div>
                  <TextBlock title={t("homeSmartTitle")}>
                    {t("homeSmartText")}
                  </TextBlock>
                  <Button
                    className="btn"
                    to="over-fpg/#more-about-us"
                    onClick=""
                  >
                    {t("homeSmartTellMeMore")}
                  </Button>
                </div>
                <div className="flex flex-column flex-justify flex-aistart">
                  <TextBlock title={t("homeStudentTitle")}>
                    {t("homeStudentText")}
                  </TextBlock>
                  <Button className="btn" to="vacatures" onClick="">
                    {t("homeStudentTellMeMore")}
                  </Button>
                </div>
              </section>
            </div>
          </main>
        )}
      </I18n>,
    ];
  }
}



// WEBPACK FOOTER //
// ./src/Pages/Home.jsx